import { render } from "./CodReceiverUpdate.vue?vue&type=template&id=5cd3a97a"
import script from "./CodReceiverUpdate.vue?vue&type=script&lang=js"
export * from "./CodReceiverUpdate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__